module.exports = __webpack_public_path__ + "static/media/marketing.e77a3bfe.svg";